// src/utils/statusBadges.ts
import {
  Package,
  Clock,
  CheckCircle,
  XCircle,
  AlertCircle,
  ShoppingBag,
  Truck,
  RefreshCw,
} from 'lucide-react';

export interface StatusConfig {
  label: string;
  className: string;
  icon: any;
}

// Product status badges
export const getProductStatusBadge = (status: string): StatusConfig => {
  const configs: Record<string, StatusConfig> = {
    draft: { label: 'Draft', className: 'bg-gray-100 text-gray-600', icon: Package },
    pending_review: { label: 'Pending Review', className: 'bg-yellow-100 text-yellow-800', icon: Clock },
    approved: { label: 'Approved', className: 'bg-green-100 text-green-800', icon: CheckCircle },
    rejected: { label: 'Rejected', className: 'bg-red-100 text-red-800', icon: XCircle },
    changes_requested: { label: 'Changes Requested', className: 'bg-orange-100 text-orange-800', icon: AlertCircle },
  };
  return configs[status] || configs.draft;
};

// Vendor status badges
export const getVendorStatusBadge = (status: string, isActive: boolean): StatusConfig => {
  if (!isActive) {
    return { label: 'Inactive', className: 'bg-gray-100 text-gray-600', icon: XCircle };
  }
  const configs: Record<string, StatusConfig> = {
    pending: { label: 'Pending', className: 'bg-yellow-100 text-yellow-800', icon: Clock },
    approved: { label: 'Approved', className: 'bg-green-100 text-green-800', icon: CheckCircle },
    rejected: { label: 'Rejected', className: 'bg-red-100 text-red-800', icon: XCircle },
  };
  return configs[status] || configs.pending;
};

// Order status badges
export const getOrderStatusBadge = (status: string): StatusConfig => {
  const configs: Record<string, StatusConfig> = {
    pending: { label: 'Pending', className: 'bg-yellow-100 text-yellow-800', icon: Clock },
    processing: { label: 'Processing', className: 'bg-blue-100 text-blue-800', icon: RefreshCw },
    shipped: { label: 'Shipped', className: 'bg-purple-100 text-purple-800', icon: Truck },
    delivered: { label: 'Delivered', className: 'bg-green-100 text-green-800', icon: CheckCircle },
    cancelled: { label: 'Cancelled', className: 'bg-red-100 text-red-800', icon: XCircle },
  };
  return configs[status] || configs.pending;
};